import React from "react";
import SimpleTable from "../tables/SimpleTable";
import RadioButton from "./RadioButton";

const RadioTable = ({ options, data, radioClicked }) => {
  const handleRadioClick = (permId, option) => () =>
    radioClicked(permId, option);

  const tableConfig = () => {
    return {
      columns: [
        {
          title: "",
          width: "472px",
          render: (x) => (
            <RadioTableSubjectDisplay title={x.title} tagline={x.tagline} />
          ),
        },
        ...options.map((opt) => ({
          title: opt.display,
          center: true,
          width: "95px",
          alignment: "center",
          render: (x) =>
            x.options.includes(opt.option) ? (
              <RadioButton
                onClick={handleRadioClick(x.id, opt.option)}
                checked={opt.option === x.currentOption}
              />
            ) : null,
        })),
      ],
    };
  };

  return <SimpleTable config={tableConfig()} data={data()} noPad noFooter />;
};

export default RadioTable;

const RadioTableSubjectDisplay = ({ title, tagline }) => {
  return (
    <div className="flex flex-col items-start">
      <span className="text-sm/6 font-medium">{title}</span>
      <span className="text-sm font-normal text-zinc-500">{tagline}</span>
    </div>
  );
};
